/**
 * 0-9纯数字键盘，用来输入交易密码
 */
import "./index.scss";

import _ from "lodash";
import { Component, Prop, Vue } from "vue-property-decorator";

import IconSvg from "@/components/Icon-svg";
import { HoldModel } from "@/shared/decorators/hold-model";

@Component({ name: "DigitKeyboard" })
export default class DigitKeyboard extends Vue {
  @HoldModel()
  private buffer!: string;

  @Prop()
  private maxLength!: number;

  private onInput(num: string) {
    if (this.maxLength && this.buffer.length >= this.maxLength) return;
    this.buffer += num;
  }

  private onDelete() {
    this.buffer = this.buffer.slice(0, this.buffer.length - 1);
  }

  private render() {
    return (
      <div v-class>
        {_.chunk(_.range(1, 10), 3).map((row) => (
          <div v-class={["row"]}>
            {row.map((num) => (
              <span v-class={["cell"]} onClick={() => this.onInput(`${num}`)}>
                {num}
              </span>
            ))}
          </div>
        ))}
        <div v-class={["row"]}>
          <span v-class={["placeholder"]}>_</span>
          <span v-class={["cell"]} onClick={() => this.onInput("0")}>
            0
          </span>
          <p v-class={["delete"]} onClick={this.onDelete}>
            <IconSvg iconClass="keyboard-delete" />
          </p>
        </div>
      </div>
    );
  }
}
